import { createGlobalStyle } from 'styled-components'

import { getTheme } from 'theme'

const theme = getTheme({})

export const GlobalStyles = createGlobalStyle`
  body, html {
    margin: 0;
    padding: 0;
  }

  html {
    font-family: Open-Sans, 'Noto Sans JP', sans-serif;
    font-size: 14px;
    scrollbar-color: #bebebe linear-gradient(
      180deg,
      rgba(241, 241, 241, 0) 0%,
      #F1F1F1 4%,
      #F1F1F1 96%,
      rgba(241, 241, 241, 0) 100%
    );
    scrollbar-width: thin;

    &.popover {
      iframe {
        pointer-events: none;
      }
    }
  }

  #root {
    height: 100vh;
  }

  ::-webkit-scrollbar {
    width: ${theme.sizes.scrollbar.size};
    height: ${theme.sizes.scrollbar.size};
  }

  ::-webkit-scrollbar-track {
    background: #F1F1F1;
    border-radius: 999px;
  }

  ::-webkit-scrollbar-thumb {
    background: #bebebe;
    border-radius: 999px;
    }

  ::-webkit-scrollbar-thumb:hover {
    background: #bebebe;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .MuiAccordion-root:before {
    background-color: rgba(0, 0, 0, .08);
  }

  .Toastify {
    z-index: 43;
    position: absolute;
  }

.dropdown-surface {
  border-radius: 4px;
  border: 1px solid  ${theme.palette.custom.border.default};
  border-top: 0px;
  background: ${theme.palette.custom.background.secondary};
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.10);
  clip-path: inset(0px -30px -30px -30px);
}

.dropdown-surface:after {
   content: "";
   border-top: ${theme.palette.custom.border.default} 1px solid;
   position: absolute;
   top: 0px;
   left: 8px;
   right: 8px;
  }

`

export const UserManualGlobalStyles = createGlobalStyle`
  @media print {
    #root {
      height: auto;
    }
  }
`
